import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { toast } from 'react-toastify';
import './Login.css';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const user = await login(email, password);
            toast.success(`Welcome back, ${user.fullName}!`);

            if (user.role === 'master_admin') {
                navigate('/master-admin/dashboard');
            } else if (user.role === 'spa_admin') {
                navigate('/admin/dashboard');
            } else {
                navigate('/');
            }
        } catch (error) {
            toast.error(error.response?.data?.error || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <h2>Admin Login</h2>
                <p>Sign in to manage your spa</p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email"
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Enter your password"
                        />
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '15px' }}>
                        <span
                            onClick={() => navigate('/forgot-password')}
                            style={{
                                color: '#6B4C93',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            Forgot Password?
                        </span>
                    </div>

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>Don't have an account?</p>
                    <p style={{ marginTop: '10px', fontSize: '14px' }}>
                        Contact Master Admin:<br />
                        📧 <a href="mailto:zot3chpvtltd@gmail.com" style={{ color: '#6B4C93', textDecoration: 'none' }}>zot3chpvtltd@gmail.com</a><br />
                        📞 <a href="tel:+918401753546" style={{ color: '#6B4C93', textDecoration: 'none' }}>+91 84017 53546</a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Login;
